// Module
var code = "<div class=full-page> <div class=loading-spinner> <i class=\"far fa-circle-notch fa-spin fa-3x fa-fw\"></i> <span class=sr-only translate>Loading</span> </div> </div> ";
// Exports
module.exports = code;